import React, { useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import { Context } from '../Store'
import { redirectToAuthWithFrom } from '../utils/UserContext'
import { getNextStep } from '../DiscoverStep/StepValidation'

const DiscoverBooking = ({ history, propertyId, legacyBookingId }) => {
  const [state, dispatch, loadBooking] = useContext(Context)

  useEffect(() => {
    loadBooking({ propertyId, legacyBookingId }).then(async ({ booking, error }) => {
      if (booking && !error) {
        const step = await getNextStep(booking)
        history.replace(`/bookings/${booking.id}/${step}`)
      } else if (error === 401) {
        redirectToAuthWithFrom()
      } else if (error === 400) {
        window.location.href = `${process.env.REACT_APP_WEBSITE}`
      }
    })
  }, [])

  return <div className="flex justify-center content-center w-full">looking for booking...</div>
}

export default withRouter(DiscoverBooking)
